import axiosClient from './axiosClient.js'
import axios from 'axios';
import { useLocation } from 'react-router-dom'
import ROUTES from "../constants/routes.js";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

/**
 * Verifica se o usuário está autenticado
 * @returns {Promise} Promise com o status da autenticação
 */
function checkSession() {
  return axiosClient.get('/api/v2/autovalid/users/check_session');
}

/**
 * Authenticate the user
 * @param {Object} user - The user trying to sign in
 * @param {string} user.email - User email.
 * @param {string} user.password - User password.
 */
function signIn(user) {  
  const { license_plate, plan_type, ...userData } = user;
  
  const payload = { 
    user: userData,
    license_plate,
    plan_type
  };

  return axios.post(
    '/api/v2/autovalid/users/client_sign_in', 
    payload, 
    { 
      headers: { 
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      } 
    }
  );
}

/**
 * Create an user account
 * @param {Object} user
 * @param {string} user.name
 * @param {string} user.last_name
 * @param {string} user.email
 * @param {string} user.document
 * @param {string} user.phone
 * @param {string} user.password
 * @param {string} user.password_confirmation
 */
function signUp(user) {
  let formData = new FormData();
  formData.append('user[name]', user.name);
  formData.append('user[last_name]', user.last_name);
  formData.append('user[email]', user.email);
  formData.append('user[document]', user.document);
  formData.append('user[phone]', user.phone);
  formData.append('user[password]', user.password);
  formData.append('user[password_confirmation]', user.password_confirmation);
  
  if (user.license_plate) {
    formData.append('license_plate', user.license_plate);
  }

  if (user.plan_type) {
    formData.append('plan_type', user.plan_type);
  }

  return axiosClient.post(ROUTES.SIGN_UP, 
    formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Accept': 'application/json'
      }
    });
}

/**
 * Request a password reset email
 * @param {Object} user
 * @param {string} user.email
 */
function requestPasswordReset(user) {
  return axiosClient.post('/users/password', { user: user });
}

/**
 * Reset user password
 * @param {Object} user
 * @param {string} user.password
 * @param {string} user.password_confirmation
 */
function resetPassword(user) {
  const query = new URLSearchParams(window.location.search);
  return axiosClient.put('/users/password', { user: { ...user, reset_password_token: query.get("reset_password_token")} });
}

const AuthorizationClient = {
  checkSession,
  signIn,
  signUp,
  requestPasswordReset,
  resetPassword
}

export default AuthorizationClient;